/**
 * Get Marketers for Distribution Use Case
 *
 * This use case handles fetching marketers available for distribution
 * following clean architecture principles.
 *
 * @module GetMarketersForDistributionUseCase
 */

import {DistributionRepository} from '../repository/DistributionRepository';
import {DistributionMarketer} from '../models/distribution.model';

export class GetMarketersForDistributionUseCase {
  constructor (private distributionRepository: DistributionRepository) {}

  async execute (search?: string): Promise<DistributionMarketer[]> {
    try {
      return await this.distributionRepository.getMarketersForDistribution(search);
    } catch (error) {
      throw error;
    }
  }
}
